import React from "react";
import { string } from "prop-types";

import UserComments from "../../molecules/UserComments";
import ProfileContainer from "../../rows/ProfileContainer";

const CommentsPage = ({ currentPath }) => (
  <ProfileContainer type="comments" hideTopAd={true} currentPath={currentPath}>
    {({ member }) => <UserComments member={member} />}
  </ProfileContainer>
);

CommentsPage.propTypes = {
  currentPath: string,
};

export { CommentsPage };
